import Vue from "vue";
import Vuex from "vuex";
import {
  queryAll
} from "@/api/col";
import {
  qrySessionInfo
} from "@/api/cache";
import {
  getSessionInfo,
  setSessionInfo
} from '@/utils/sessionStorage'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {},
    routeName: "home",
    routeParentPath: '',
    searchKey: '',
    menuList: [],
    currentMenu: getSessionInfo('currentMenu')
  },
  getters: {
    userInfo: state => state.userInfo,
    routeName: state => state.routeName,
    routeParentPath: state => state.routeParentPath,
    searchKey: state => state.searchKey,
    menuList: state => state.menuList,
    currentMenu: state => state.currentMenu
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setCurrentRouteName(state, name) {
      state.routeName = name;
    },
    setCurrentRouteParentPath(state, parentPath) {
      state.routeParentPath = parentPath
    },
    setSearchKey(state, searchKey) {
      state.searchKey = searchKey;
    },
    setMenuList(state, menuList) {
      state.menuList = menuList
    },
    setCurrentMenu(state, currentMenu) {
      setSessionInfo('currentMenu', currentMenu)
      state.currentMenu = currentMenu
    }
  },
  actions: {
    getUserInfo({
      commit
    }, userId) {
      return qrySessionInfo({
          userId: userId + "_USER_INFO"
        })
        .then(res => {
          commit("setUserInfo", res);
          return res;
        })
        .catch(err => {
          return err;
        });
    },
    queryAll({
      commit
    }, site) {
      return queryAll({
        isShow: 1,
        site
      }).then((res) => {
        commit('setMenuList', res)
      });
    }
  }
});